;(function() {
  'use strict'

  service.$inject = ["$log", "$q", "$state", "locationService", "searchResource", "elementsResource", "pageService", "pageSelector"];
  angular.module('core.services').factory('searchService', service)

  /* @ngInject */
  function service(
    $log,
    $q,
    $state,
    locationService,
    searchResource,
    elementsResource,
    pageService,
    pageSelector
  ) {
    var log = $log.create('searchService')

    var DefaultImages = {
      PAGE: 'img/result-page-image.png',
      PLACE: 'img/result-place-image.png',
      PRODUCT: 'img/result-product-image.png',
      OTHER: 'img/result-other-image.png',
    }

    var Types = {
      ALL: ['page', 'place', 'product', 'other'],
      PAGE: 'page',
      PLACE: 'place',
      PRODUCT: 'product',
      OTHER: 'other',
    }

    return {
      search: search,
      route: route,
      Types: Types,
    }

    function search(query, opts) {
      return $q(function(resolve, reject) {
        // defaults
        var options = _.defaults(opts, {
          type: Types.ALL,
          limit: 10,
          location: locationService.latest.encoded || {},
        })

        if (_.isArray(options.type)) {
          options.type = options.type.join(',')
        }

        var data = {
          query: query,
          type: options.type,
          limit: options.limit,
          location: options.location,
        }

        searchResource
          .query(data)
          .success(function(x, results) {
            addExtras(results)
            resolve(results)
          })
          .error(function() {
            reject()
          })
      })
    }

    function route(result) {
      if (result.type === Types.PAGE) {
        routeToPage(result)
      } else {
        routeToElement(result)
      }
    }

    function routeToPage(result) {
      $state.go('app.page', { id: result.pageId })
    }

    function routeToElement(result) {
      getElementId(result).then(function(elementId) {
        pageService.getByElement(elementId).then(function(pages) {
          // no pages? go to element
          if (!pages.length) {
            var state = 'app.portal.' + result.type
            return $state.go(state, { id: elementId })
          }

          // one page? go direct!
          if (pages.length === 1) {
            return $state.go('app.page', {
              id: pages[0].id,
              elementId: elementId,
            })
          }

          // otherwise show page selector
          pageSelector.prompt(pages).then(function(page) {
            $state.go('app.page', { id: page.id, elementId: elementId })
          })
        })
      })
    }

    function getElementId(result) {
      return $q(function(resolve, reject) {
        // reject if not element
        if (result.type === Types.PAGE) {
          return reject()
        }

        // resolve if already known
        if (result.elementId) {
          return resolve(result.elementId)
        }

        // create element from sourceId
        if (result.sourceId) {
          var data = {
            type: result.type,
            elementItemId: result.sourceId,
          }

          elementsResource
            .create(data)
            .success(function(x, element) {
              resolve(element.id)
            })
            .error(function() {
              reject()
            })

          return
        }

        log.error('result has no elementId OR sourceId')
        reject()
      })
    }

    function addExtras(results) {
      if (!_.isArray(results)) {
        results = [results]
      }
      _.each(results, function(result) {
        result.extras = {}
        result.extras.imageStyle = getImageStyle(result)
      })
    }

    function getImageStyle(result) {
      var imageUrl = result.imageUrl
      var themeColor = result.themeColor

      // no image - use default
      if (!imageUrl) {
        var typeKey = result.type.toUpperCase()
        imageUrl = DefaultImages[typeKey]
      }

      // resize cloudinary images
      var isCloudinary = _.includes(imageUrl, 'cloudinary')
      if (isCloudinary) {
        imageUrl = imageUrl.replace('/upload/', '/upload/h_100/')
      }

      // base image styles
      var style = {
        backgroundImage: 'url(' + imageUrl + ')',
      }

      // apply themeColor if one
      if (themeColor) {
        if (themeColor[0] !== '#') {
          themeColor = '#' + themeColor
        }
        style.backgroundColor = themeColor
      }

      return style
    }
  }
})()
